import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import DatePicker , { registerLocale } from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";

import './SolicitacaoComunicacao.css';
import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { EMAIL, PLATAFORMA } from "../../providers/constCanaisComunicacao";
import { RESPONSAVEL_TECNICO, DIRIGENTE_TI } from "../../providers/constAtribuicoesGestor";
import { GESTOR_API, GESTOR_ARQUIVO_GV } from "../../providers/constGestorFornecedor";
import { ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API, ID_AUDIENCIA_SOL_COM_FORNECEDOR_API, ID_AUDIENCIA_SOL_COM_OPERADOR_API, ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV, ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV, ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS } from "../../providers/constAudienciaSolicitacaoComunicacao";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

registerLocale("pt_br", pt_br);
export const SolicitacaoComunicacaoView =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: '',
					numero: '',
					situacao: '',
					nomeSituacao: '',
					audiencia: '',
					nenhumPerfilPesquisaSelecionado: true,
					aplicacacoesFornecedoras: [],
					arquivosGV: [],
					ufs: [],
					orgaos: [],
					esferasAdministrativas: [],
					naturezasJuridicas: [],
					canaisComunicacao: [],
					tiposGestores: [],
					assunto: '',
					mensagem: '',
					dataEnvioComunicacao: new Date(),
					liberarParaProcessamento: false,
					alteracaoPermitida: true,
					liberacaoProcessamentoPermitida: false,
				},
				aplicacacoesFornecedorasDisponiveis: [],
				arquivosGVDisponiveis: [],
				orgaosDisponiveis: [],
				orgaosOperadoresDisponiveis: [],
				ufsDisponiveis: [],
				esferasAdministrativasDisponiveis: [ESTADUAL, FEDERAL, MUNICIPAL],
				naturezasJuridicasDisponiveis: [],
				canaisComunicacaoDisponiveis: [EMAIL, PLATAFORMA],
				tiposGestoresDisponiveis: [GESTOR_API, GESTOR_ARQUIVO_GV, DIRIGENTE_TI, RESPONSAVEL_TECNICO],
				carregandoFornecedoras: false,
				carregandoArquivosGV: false,
				carregandoOrgaos: false,
				carregandoOrgaosOperadores: false,
				carregandoNaturezas: false,
				carregandoUfs: false,
				exibeModalConfirmacao : false,
				msgModal: '',
				botoesHabilitados : true,
			};
			
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Comunicação</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;

			if(id){
				api.get(`/api/solicitacao-comunicacao/${id}`)
					.then(response => { 
						const solicitacao = response.data;

						this.setState((prevState) => ({ ...prevState, solicitacao })) ;
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar a solicitação de comunicação.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					});
				}
			}

		renderForm() {
			const { solicitacao } = this.state;

			return(
				<div className="container-fluid">

					<div className="br-form">
						{ solicitacao.id &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Número:</label>
											<input value={solicitacao.numero} readOnly/>
										</div>
									</div>
								</div>
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Situação:</label>
											<input value={solicitacao.nomeSituacao} readOnly/>
										</div>
									</div>
								</div>
							</div>
						}

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Audiência:</label>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia"  
										checked={! solicitacao.audiencia} 
										readOnly />
									<label>Todos os Gestores</label>
								</div>	
							</div>
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API} 
										readOnly />
									<label>Somente para Consumidores de APIs</label>
								</div>	
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="aplicacoesFornecedoras">APIs:</label>
											<textarea name="aplicacoesFornecedoras" readOnly  style={{height:"90px"}}
												value={ (solicitacao.aplicacacoesFornecedoras && solicitacao.aplicacacoesFornecedoras.length > 0) 
													? solicitacao.aplicacacoesFornecedoras.map(fornecedora => fornecedora.nome).join('\n')
													: 'Consumidores de todas as APIs, sem distinção'
												}
											/>
										</div>
									</div>
								</div>	
							}
						</div>
						<div className="row">
							<div className="col-sm-4">									
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_FORNECEDOR_API} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API} 
										readOnly />
									<label>Somente para Fornecedores de APIs</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="aplicacoesFornecedoras">APIs:</label>
											<textarea name="aplicacoesFornecedoras" readOnly  style={{height:"90px"}}
												value={ (solicitacao.aplicacacoesFornecedoras && solicitacao.aplicacacoesFornecedoras.length > 0) 
													? solicitacao.aplicacacoesFornecedoras.map(fornecedora => fornecedora.nome).join('\n')
													: 'Fornecedores de todas as APIs, sem distinção'
												}
											/>
										</div>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_OPERADOR_API} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_OPERADOR_API} 
										readOnly />
									<label>Somente para Operadores de APIs</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_OPERADOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="orgaos">Órgãos:</label>
											<textarea name="orgaos" readOnly  style={{height:"90px"}}
												value={ (solicitacao.orgaos && solicitacao.orgaos.length > 0) 
													? solicitacao.orgaos.map(orgao => orgao.nome).join('\n')
													: 'Operadores de todos os órgãos, sem distinção'
												}
											/>
										</div>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV}
										readOnly />
									<label>Somente para Consumidores de Arquivos</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_CONSUMIDOR_ARQUIVO_GV &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="arquivosGV">Arquivos:</label>
											<textarea name="arquivosGV" readOnly  style={{height:"90px"}}
												value={ (solicitacao.arquivosGV && solicitacao.arquivosGV.length > 0) 
													? solicitacao.arquivosGV.map(arquivo => arquivo.nome).join('\n')
													: 'Consumidores de todos os arquivos, sem distinção'
												}
											/>
										</div>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV}
										readOnly />
									<label>Somente para Fornecedores de Arquivos</label>
								</div>
							</div>	
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_FORNECEDOR_ARQUIVO_GV &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="arquivosGV">Arquivos:</label>
											<textarea name="arquivosGV" readOnly  style={{height:"90px"}}
												value={ (solicitacao.arquivosGV && solicitacao.arquivosGV.length > 0) 
													? solicitacao.arquivosGV.map(arquivo => arquivo.nome).join('\n')
													: 'Fornecedores de todos os arquivos, sem distinção'
												}
											/>
										</div>
									</div>
								</div>	
							}
						</div>

						<div className="row">
							<div className="col-sm-4">
								<div class="check input br-radio recuo_esquerda">
									<input type="radio" name="audiencia" id="audiencia"
										value={ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS} 
										checked={solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS}
										readOnly />
									<label>Somente para Pontos Focais</label>
								</div>
							</div>
							{solicitacao.audiencia === ID_AUDIENCIA_SOL_COM_PONTOS_FOCAIS &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="naturezasJuridicas">Naturezas Jurídicas:</label>
											<textarea name="naturezasJuridicas" readOnly  style={{height:"90px"}}
												value={ (solicitacao.naturezasJuridicas && solicitacao.naturezasJuridicas.length > 0) 
													? solicitacao.naturezasJuridicas.map(natureza => natureza.id + ' - ' +natureza.nome).join('\n')
													: 'Pontos focais de todas as naturezas jurídicas, sem distinção'
												}
											/>
										</div>
									</div>
								</div>	
							}
						</div>
						
						<br/>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="esferasAdministrativas">Esferas Administrativas de destino:</label>
										<textarea name="esferasAdministrativas" readOnly  style={{height:"90px"}}
											value={ (solicitacao.esferasAdministrativas && solicitacao.esferasAdministrativas.length > 0) 
												? solicitacao.esferasAdministrativas.map(esfera => esfera.nome).join('\n')
												: 'Todas as esferas administrativas, sem distinção'
											}
										/>
									</div>	
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="ufs">Unidades da Federação de destino:</label>
										<textarea name="ufs" readOnly  style={{height:"90px"}}
											value={ (solicitacao.ufs && solicitacao.ufs.length > 0) 
												? solicitacao.ufs.map(uf => uf.id).join('\n')
												: 'Todas as unidades da federação, sem distinção'
											}
										/>
									</div>	
								</div>
							</div>

							{ solicitacao.audiencia !== ID_AUDIENCIA_SOL_COM_OPERADOR_API &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label for="orgaos">Órgãos de destino:</label>
											<textarea name="orgaos" readOnly  style={{height:"90px"}}
												value={ (solicitacao.orgaos && solicitacao.orgaos.length > 0) 
													? solicitacao.orgaos.map(orgao => orgao.nome).join('\n')
													: 'Todos os órgãos, sem distinção'
												}
											/>
										</div>	
									</div>
								</div>
				}
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="tiposGestores">Destinatários:</label>
										<textarea name="tiposGestores" readOnly  style={{height:"90px"}}
											value={ (solicitacao.tiposGestores && solicitacao.tiposGestores.length > 0) 
												? solicitacao.tiposGestores.map(tipoGestor => tipoGestor.nome).join('\n')
												: 'Todos os gestores, sem distinção'
											}
										/>
									</div>
								</div>
							</div>

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label for="canaisComunicacao">Canais de Comunicação:</label>
										<textarea name="canaisComunicacao" readOnly  style={{height:"90px"}}
											value={ (solicitacao.canaisComunicacao && solicitacao.canaisComunicacao.length > 0) 
												? solicitacao.canaisComunicacao.map(canal => canal.nome).join('\n')
												: ''
											}
										/>
									</div>	
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="assunto">Assunto:</label>
										<input type="text" name="assunto" value={solicitacao.assunto} readOnly/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">  
								<div className="field">
									<div className="input"> 
										<label htmlFor="mensagem">Mensagem:</label>
										<textarea name="mensagem" value={solicitacao.mensagem} style={{height:"90px"}} readOnly/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-3">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="dataEnvioComunicacao">Data de envio da comunicação:</label>
										<DatePicker 
											locale="pt_br" 
											dateFormat="dd/MM/yyyy" 
											selected={solicitacao.dataEnvioComunicacao} 
												disableClock={true}
												readOnly
											/>
                                    </div>
                                </div>
                            </div>
                        </div>

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{ solicitacao.alteracaoPermitida &&
									<Link to={`/solicitacao-comunicacao/edit/${solicitacao.id}`}>
										<button type="button" className="button is-secondary botaoNovo">Alterar</button>
									</Link>
								}

								{ solicitacao.visualizacaoMensagensPermitida &&
									<Link to={`/solicitacao-comunicacao/messages/${solicitacao.id}`}>
										<button type="button" className="button is-secondary">Visualizar mensagens</button>
									</Link>
								}

								<ButtonBack/>
							</div>
						</div>
					</div>
				</div>
				
			);
		}
	
	}

) // redux
); // router